import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ISettingsTable } from 'src/app/@amiga-pyme/interfaces/table.interface';
import { TableActionsTemplate } from 'src/app/@amiga-pyme/table-actions/templates/table-actions.template';
import { TransferDetailService } from './transfers-details.service';

@Component({
  templateUrl: './transfer-details.component.html',
  selector: 'pg-transfer-detail'
})
export class TransferDetailComponent /*extends TableActionsTemplate*/ {
  visible = true;
  @Input() idDocument: number;
  @Output() onHideData = new EventEmitter<boolean>();
  tableDetailSettings: ISettingsTable;
  detailTransfer: any[];

  constructor(private transferDetailService: TransferDetailService) {}

  async ngOnInit() {
    this.tableDetailSettings = {
      title: 'Detalle de documento',
      columns: [
        { header: 'Descripción', field: 'description' },
        { header: 'Lote', field: 'lot' },
        { header: 'Cantidad.', field: 'quantity' },
        { header: 'Formato', field: 'format' }
      ]
    };

    const { data: detailTransfer, status } =
      await this.transferDetailService.getById(this.idDocument);

    if (status === 200) {
      this.detailTransfer = this.flattenDetailsTransfer(
        detailTransfer as any[]
      );
      this.visible = true;
    }
  }

  flattenDetailsTransfer(transferResponse: any[]) {
    const flattenedDetails = [];
    for (const transferDetail of transferResponse) {
      Object.entries(transferDetail.formats).map(
        ([formatName, formatDetails]) => {
          const newFlattenedDetail = {
            description: transferDetail.description,
            lot: transferDetail.lot,
            format: formatName,
            quantity: formatDetails['cantidad']
          };
          flattenedDetails.push(newFlattenedDetail);
        }
      );
    }
    return flattenedDetails;
  }

  onHideDataDialog() {
    this.visible = false;
    this.idDocument = undefined;
    this.onHideData.emit();
  }
}
